import { checkoutUserErrorFragment } from './fragmentGeneral.gql';

const accountLogin = (
	`mutation customerRecover($email: String!) {
		customerRecover(email: $email) {
			customerUserErrors ${checkoutUserErrorFragment}
		}
	}`
);

export default accountLogin;
